module.exports = __webpack_public_path__ + "img/service.b7dca947.jpg";